export const APP_NAME = 'Altus Academy';
